export const fontAdelleSans = "Adelle Sans";
export const fontAvenirNext = "Avenir Next";
export const fontClearSans = "Clear Sans";
export const fontOpenSans = "Open Sans";
export const fontMonoLisa = "Mono Lisa";
export const familyBody = "Adelle Sans, Work Sans, Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif";
export const familyBrand = "Adelle Sans, Work Sans, Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif";
export const familyDisplay = "Adelle Sans, Work Sans, Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif";
export const familyCode = "Mono Lisa, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", monospace";
export const legacyFamilyBody = "Open Sans, Clear Sans, Helvetica Neue, Helvetica, Arial, sans-serif";
export const legacyFamilyBrand = "Avenir Next, Helvetica Neue, Helvetica, Arial, sans-serif";
export const legacyFamilyDisplay = "Avenir Next, Helvetica Neue, Helvetica, Arial, sans-serif";
export const legacyWeightBody = 400;
export const legacyWeightDisplay = 700;
export const legacyWeightHeading = 600;
export const legacyWeightHeadingLight = 600;
export const styleNormal = "normal";
export const styleItalic = "italic";
export const size50 = "10px";
export const size100 = "12px";
export const size200 = "14px";
export const size300 = "16px";
export const size400 = "18px";
export const size500 = "20px";
export const size600 = "24px";
export const size700 = "36px";
export const size800 = "48px";
export const size900 = "60px";
export const size1000 = "72px";
export const sizeBase = "16px";
export const height50 = "12px";
export const height100 = "16px";
export const height200 = "20px";
export const height300 = "24px";
export const height400 = "28px";
export const height500 = "32px";
export const height600 = "36px";
export const height700 = "48px";
export const height800 = "60px";
export const height900 = "72px";
export const height1000 = "80px";
export const weight100 = 100;
export const weight300 = 300;
export const weight400 = 400;
export const weight500 = 500;
export const weight600 = 600;
export const weight700 = 700;
export const weightBody = 400;
export const weightBodyBold = 700;
export const weightBodySemiBold = 600;
export const weightHeading = 700;
export const weightHeadingLight = 600;
export const weightDisplay = 400;
export const heading100Family = "Adelle Sans, Work Sans, Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif";
export const heading100Size = "14px";
export const heading100Height = "20px";
export const heading100Weight = 600;
export const heading100Color = "#333333";
export const heading100Margin = "4px";
export const heading200Family = "Adelle Sans, Work Sans, Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif";
export const heading200Size = "16px";
export const heading200Height = "24px";
export const heading200Weight = 600;
export const heading200Color = "#333333";
export const heading200Margin = "4px";
export const heading300Family = "Adelle Sans, Work Sans, Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif";
export const heading300Size = "18px";
export const heading300Height = "28px";
export const heading300Weight = 600;
export const heading300Color = "#333333";
export const heading300Margin = "8px";
export const heading400Family = "Adelle Sans, Work Sans, Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif";
export const heading400Size = "20px";
export const heading400Height = "32px";
export const heading400Weight = 600;
export const heading400Color = "#333333";
export const heading400Margin = "12px";
export const heading500Family = "Adelle Sans, Work Sans, Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif";
export const heading500Size = "24px";
export const heading500Height = "36px";
export const heading500Weight = 600;
export const heading500Color = "#333333";
export const heading500Margin = "16px";
export const heading600Family = "Adelle Sans, Work Sans, Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif";
export const heading600Size = "36px";
export const heading600Height = "48px";
export const heading600Weight = 600;
export const heading600Color = "#333333";
export const heading600Margin = "24px";
export const heading650Family = "Adelle Sans, Work Sans, Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif";
export const heading650Size = "36px";
export const heading650Height = "48px";
export const heading650Weight = 600;
export const heading650Color = "#333333";
export const heading650Margin = "24px";
export const heading700Family = "Adelle Sans, Work Sans, Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif";
export const heading700Size = "48px";
export const heading700Height = "60px";
export const heading700Weight = 600;
export const heading700Color = "#333333";
export const heading700Margin = "32px";
export const heading800Family = "Adelle Sans, Work Sans, Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif";
export const heading800Size = "60px";
export const heading800Height = "72px";
export const heading800Weight = 600;
export const heading800Color = "#333333";
export const heading800Margin = "32px";
export const heading900Family = "Adelle Sans, Work Sans, Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif";
export const heading900Size = "72px";
export const heading900Height = "80px";
export const heading900Weight = 600;
export const heading900Color = "#333333";
export const heading900Margin = "32px";
export const body200Family = "Adelle Sans, Work Sans, Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif";
export const body200Size = "10px";
export const body200Height = "12px";
export const body200Weight = 400;
export const body200Style = "normal";
export const body200Color = "#333333";
export const body300Family = "Adelle Sans, Work Sans, Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif";
export const body300Size = "12px";
export const body300Height = "16px";
export const body300Weight = 400;
export const body300Style = "normal";
export const body300Color = "#333333";
export const body400Family = "Adelle Sans, Work Sans, Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif";
export const body400Size = "14px";
export const body400Height = "20px";
export const body400Weight = 400;
export const body400Style = "normal";
export const body400Color = "#333333";
export const body500Family = "Adelle Sans, Work Sans, Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif";
export const body500Size = "16px";
export const body500Height = "24px";
export const body500Weight = 400;
export const body500Style = "normal";
export const body500Color = "#333333";
export const body600Family = "Adelle Sans, Work Sans, Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif";
export const body600Size = "18px";
export const body600Height = "28px";
export const body600Weight = 400;
export const body600Style = "normal";
export const body600Color = "#333333";
export const bodyBoldWeight = 700;
export const bodyItalicStyle = "italic";
export const headingAliasesXs = 100;
export const headingAliasesSmall = 200;
export const headingAliasesMedium = 400;
export const headingAliasesLarge = 600;
export const headingAliasesXl = 700;
export const headingAliasesXxl = 900;
export const bodyAliasesFootnote = 200;
export const bodyAliasesSmall = 300;
export const bodyAliasesMedium = 400;